// @flow

import getMapStateToPropsEdit from 'Widget/libs/primitive/getMapStateToPropsEdit';

const mapDispatchToPropsEdit = getMapStateToPropsEdit;

export default mapDispatchToPropsEdit;
